module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-faq container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.faqdata) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.faqdata.title) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "list",
    staticStyle: {
      "list-style": "none",
      "margin-left": "0",
      "margin-top": "45px"
    }
  }, _vm._l((_vm.faqs), function(faq, index) {
    return _c('li', {
      key: ("" + index)
    }, [_c('div', {
      staticClass: "subtitle minimal-margin"
    }, [_vm._v("\n              " + _vm._s(faq.title) + "\n            ")]), _vm._v(" "), (faq.content) ? _c('markdown', {
      attrs: {
        "source": faq.content
      }
    }) : _vm._e()], 1)
  }), 0)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45a574dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Faq.vue
// module id = 971
// module chunks = 1